import http from '../../../../../libs/http'

const api = `${process.env.VUE_APP_MICROSERVICE_API_AMORTIZATIONS}/dashboard/banks`

export default ({ id }) => http.get(`${api}/${id}`)
